

<div class="modal-header">
    <h5 class="modal-title" id="exampleModalLabel">Please confirm your email</h5>
<!--    <button-->
<!--            type="button"-->
<!--            class="close"-->
<!--            (click)="onClose()"-->
<!--    >-->
<!--        <img src="assets/icons/close.png" alt="close-icon"/>-->
<!--    </button>-->
</div>
<div class="modal-body">
        <input id="email" placeholder="Email" type="email" class="input" [(ngModel)]="email">

        <button class="email-login"
                [disabled]="!email"
                (click)="confirmEmail()">
            Увійти
        </button>
</div>
